import { Trash2, Download, X } from "lucide-react";
import Button from "../ui/button/Button";

interface SelectionBarProps {
  count: number;
  onClear: () => void;
}

export default function CheckboxSelection({ count, onClear }: SelectionBarProps) {
  if (count === 0) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[999]">
      <div className="flex items-center gap-4 bg-white shadow-xl border border-gray-200 rounded-xl px-5 py-3 animate-in fade-in slide-in-from-bottom-2">

        {/* Count */}
        <div className="flex items-center gap-2 text-sm font-medium text-gray-700">
          <span className="bg-indigo-600 text-white text-xs px-2 py-1 rounded-full">
            {count}
          </span>
          Ticket selected
        </div>

        {/* Divider */}
        <div className="h-5 w-px bg-gray-200" />

        {/* Actions */}
        <button className="flex items-center gap-1 text-sm text-gray-600 hover:text-red-600 transition cursor-pointer">
          <Trash2 size={16} />
          Delete
        </button>

        <Button className="flex items-center gap-1 text-sm text-gray-600 hover:text-white transition cursor-pointer px-[10px] py-[5px]">
          <Download size={16} />
          Export
        </Button>

        {/* Close */}
        <Button
          onClick={onClear}
          className=" px-[10px] py-[5px] !bg-gray-100 !text-gray-600 hover:!bg-gray-200 hover:!text-gray-900 cursor-pointer rounded-md  p-1.5">
          <X size={18} />
        </Button>
      </div>
    </div>
  );
}